export interface GeneralCsvReportEntity {

    reportType: string,
    printer: string,
    fileLocation: string,
    opsLine?: string | null,
    month: string,
    year: string,
    exportType?: string | null,
    customerType?: string | null,
    includeNonVat?: string | null,
    docDateFrom?: Date | null,
    docDateTo?: Date | null,


    [key: string]: string | boolean | Date | number | null | Object | undefined
}

export const EMPTY_GENERAL_CSV_REPORT_ENTITY: GeneralCsvReportEntity = {
    reportType: "",
    printer: "dummy",
    fileLocation: "",
    opsLine: null,
    month: "",
    year: "",
    exportType: null,
    includeNonVat: "Y",
    docDateFrom: null,
    docDateTo: null,
    customerType: null,
}
